import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import messages from "../../../redux/messages";
import SibebarDescriptorsProfiles from "../../../components/descriptorsProfiles/SibebarDescriptorsProfiles";
import {
  deleteCompetenciesType,
  editCompetenciesType,
  getCompetenciesType,
  saveCompetenciesType,
} from "../../../redux/descriptorsProfiles/CompetenciesType/actions";

const CompetenciesType = (props) => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const schema = Yup.object().shape({
    descripcion: Yup.string().required("**Campo requerido"),
    numero_competencia: Yup.number().required("**Campo requerido"),
    competencia_indispensable: Yup.boolean().notRequired(""),
  });

  const {
    loading,
    saveLoading,
    competenciesTypesLength,
    competenciesTypes,
    competenciesTypeError,
    formError,
  } = useSelector((store) => store.competenciesType);
  const pages = Math.ceil(competenciesTypesLength / limit);

  const columns = [
    {
      Header: "Nombre",
      accessor: "descripcion",
    },
    {
      Header: "Numero de competencias",
      accessor: "numero_competencia",
      // Filter: "",
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const getACompetenciesType = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getCompetenciesType({
        offset: offs,
        limit: lim,
        tipo_busqueda: "descripcion",
        filter: filt,
      })
    );

  useEffect(() => {
    getACompetenciesType();
  }, []);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getACompetenciesType(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (req) => {
    if (!edit) {
      dispatch(saveCompetenciesType(req, setShowModal));
    } else {
      dispatch(editCompetenciesType(req, editItem.id, index, setShowModal));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getACompetenciesType(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteCompetenciesType(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SibebarDescriptorsProfiles show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              Tipo de competencia
            </h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            competenciesTypesLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={competenciesTypes} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={competenciesTypesLength}
                  pages={pages}
                  pagFunc={getACompetenciesType}
                />
              </>
            )
          )}
          {!loading &&
            competenciesTypesLength === 0 &&
            competenciesTypeError === "" && (
              <Alert variant="info" className="my-4">
                Aún no hay registros, comience agregando algunos
              </Alert>
            )}
          {!!competenciesTypeError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {competenciesTypeError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            descripcion: edit ? editItem.descripcion : "",
            numero_competencia: edit ? editItem.numero_competencia : "",
            competencia_indispensable: edit
              ? editItem.competencia_indispensable
              : false,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit
                    ? "Editar tipo de competencia"
                    : "Crear tipo de competencia"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Nombre de competencia
                  </Form.Label>
                  <Form.Control
                    id="descripcion"
                    name="descripcion"
                    isInvalid={touched.descripcion && errors.descripcion}
                    isValid={touched.descripcion && !errors.descripcion}
                    onBlur={handleBlur("descripcion")}
                    onChange={handleChange}
                    value={values.descripcion}
                    className="rounded-pill"
                    type="text"
                    placeholder="Nombre de competencia"
                  ></Form.Control>
                  {touched.descripcion && errors.descripcion && (
                    <div>
                      <small className="text-danger">
                        {errors.descripcion}
                      </small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Numero de competencias
                  </Form.Label>
                  <Form.Control
                    id="numero_competencia"
                    name="numero_competencia"
                    isInvalid={
                      touched.numero_competencia && errors.numero_competencia
                    }
                    isValid={
                      touched.numero_competencia && !errors.numero_competencia
                    }
                    onBlur={handleBlur("numero_competencia")}
                    onChange={handleChange}
                    value={values.numero_competencia}
                    className="rounded-pill"
                    type="number"
                    placeholder="0"
                  ></Form.Control>
                  {touched.numero_competencia && errors.numero_competencia && (
                    <div>
                      <small className="text-danger">
                        {errors.numero_competencia}
                      </small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mx-2 my-3">
                  <div className="d-flex aling-items-center justify-content-between pl-2 pr-3 pt-3">
                    <label htmlFor="active">Es obligatorio</label>
                    <Form.Check
                      id="competencia_indispensable"
                      name="competencia_indispensable"
                      isInvalid={
                        touched.competencia_indispensable &&
                        errors.competencia_indispensable
                      }
                      isValid={
                        touched.competencia_indispensable &&
                        !errors.competencia_indispensable
                      }
                      onBlur={handleBlur("competencia_indispensable")}
                      onChange={(e) => {
                        setFieldValue(
                          "competencia_indispensable",
                          e.target.checked
                        );
                      }}
                      value={values.competencia_indispensable}
                      className="rounded-pill"
                      type="switch"
                      defaultChecked={
                        edit ? editItem.competencia_indispensable : null
                      }
                    />
                    {touched.competencia_indispensable &&
                      errors.competencia_indispensable && (
                        <div>
                          <small className="text-danger">
                            {errors.competencia_indispensable}
                          </small>
                        </div>
                      )}
                  </div>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default CompetenciesType;
